import React, { useEffect, useRef, useState } from "react";
import { Search, ChevronDown, LayoutTemplate, Video, ImageIcon, Mic, FileText, AlertCircle, Clock, Check, CheckCheck } from "lucide-react";
import { useAPI } from "../Context/MyContext";
import Avatar from "react-avatar";


const ContactList = ({ selectedContactId, setSelectedContactId, filter, setFilter, register, setTotalUnread }) => {
  const { getPhoneAll, getAllRecipientByPhoneId, socket, getAllRecipientByPhoneIdWithStatus, searchConversations } = useAPI();
  const [phones, setPhones] = useState([]);

  const [selectedPhone, setSelectedPhone] = useState(null);
  const [open, setOpen] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true); // ← true so skeleton shows immediately
  // const [totalUnread, setTotalUnread] = useState(0); // 🆕 total unread counter
  const [activeChatNumber, setActiveChatNumber] = useState(null);
  const [searchTerm, setSearchTerm] = useState("")

  const [page, setPage] = useState(1);

  const [hasMore, setHasMore] = useState(true);
  const pageRef = useRef(page);




//   const avatarColors = [
//   "#4B5563",
//   "#475569",
//   "#4A5568",
//   "#5B6472",
//   "#556B6F",
//   "#6B7280",
// ];



  // console.log("first phones are:", selectedPhone)


  // Fetch all phones on mount
  useEffect(() => {
    const fetchPhones = async () => {
      try {
        const res = await getPhoneAll();
        if (res?.success && Array.isArray(res.data)) {
          const formattedPhones = res.data.map((p) => ({
            id: p.phone_number_id,
            display_phone_number: p.display_phone_number,
            waba_id: p.waba_id,
            status: p.status,
            verified_name: p.verified_name,
            platform_type: p.platform_type,
          }));

          setPhones(formattedPhones);
          if (formattedPhones.length > 0 && !selectedPhone) {
            setSelectedPhone(formattedPhones[0]);
          }
        }
      } catch (err) {
        console.error("Error fetching phones:", err);
      }
    };
    fetchPhones();
  }, []);
  useEffect(() => {
    if (!selectedPhone?.id) return;

    const delayDebounce = setTimeout(() => {
      handleSearch();
    }, 400); // debounce 400ms

    return () => clearTimeout(delayDebounce);
  }, [searchTerm, selectedPhone]);




  const handleSearch = async () => {
    if (!selectedPhone?.id) return;

    //  If search empty → reset to normal list
    if (!searchTerm.trim()) {
      setPage(1);
      setHasMore(true);
      fetchRecipients(1);
      return;
    }

    try {
      setLoading(true);

      const response = await searchConversations({
        phoneNumberId: selectedPhone.id,
        search: searchTerm,
      });

      const mappedContacts = response.data.map((item) => ({
        id: item.id,
        name: item.name,
        number: item.number,
        lastMessage: item.lastMessage,
        type: item.type,
        direction: item.direction,
        status: item.status,
        time: item.lastMessageTime
          ? new Date(item.lastMessageTime).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })
          : "",
        unread: item.unreadCount,
        // image: `https://ui-avatars.com/api/?name=${item.name || item.number}`,
      }));

      setContacts(mappedContacts);

      // 🚫 Disable infinite scroll in search mode
      setHasMore(false);
    } catch (error) {
      console.error("Search failed:", error);
    } finally {
      setLoading(false);
    }
  };


  // Listen for socket message updates
  useEffect(() => {
    if (!socket) return;

    const handleMessageUpdate = (data) => {
      // console.log("📩 Message event:", data);

      const messageType = data?.type || "text";

      let messagePreview = "";

      switch (messageType) {
        case "text":
          messagePreview = data?.text?.body || "";
          break;
        case "image":
          messagePreview = "Sent an image";
          break;
        case "video":
          messagePreview = "Sent a video";
          break;
        case "audio":
          messagePreview = "Sent an audio";
          break;
        case "document":
          messagePreview = "Sent a document";
          break;
        case "template":
          messagePreview = "Sent a template";
          break;
        default:
          messagePreview = "New message";
      }



      const messageText = data?.text?.body || "";
      const recipientNumber = data?.recipient_id;
      const direction = data?.direction; // "received" | "sent"
      const createdAt = data?.createdAt || new Date().toISOString();

      const time = new Date(createdAt).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });

      setContacts((prevContacts) => {
        const existingIndex = prevContacts.findIndex(
          (c) => c.number === recipientNumber
        );

        //  if message belongs to currently open chat, mark as read and no notification
        const isActiveChat = activeChatNumber === recipientNumber;




        // 🔔 Optional desktop notification + sound (only if not current chat)
        if (direction === "received" && !isActiveChat) {
          if (Notification.permission === "default") {
            Notification.requestPermission();
          }

          if (Notification.permission === "granted") {
            new Notification("📩 New Message", {
              body: messageText || "New message received",
              icon: "/chat-icon.png",
            });
          }

          const audio = new Audio("/notification.mp3");
          audio.play().catch(() => { });
        }

        //  Update existing contact or add new one
        if (existingIndex !== -1) {
          const existing = prevContacts[existingIndex];

          const updatedContact = {
            ...existing,
            // lastMessage: messageText,
            lastMessage: messagePreview,
            type: messageType,
            direction: direction,
            status: data?.status || existing.status,
            time,
            unread:
              direction === "received"
                ? isActiveChat
                  ? 0
                  : (existing.unread || 0) + 1
                : existing.unread || 0,
          };

          // Move to top of list
          const updatedList = [
            updatedContact,
            ...prevContacts.filter((_, i) => i !== existingIndex),
          ];

          return updatedList;
        } else {
          // 🆕 Add a new contact to the top
          const newContact = {
            id: data._id,
            name: recipientNumber,
            number: recipientNumber,
            // lastMessage: messageText,
            lastMessage: messagePreview,
            type: messageType,
            direction: direction,
            status: data?.status,
            time,
            unread: direction === "received" && !isActiveChat ? 1 : 0,
            // image: `https://ui-avatars.com/api/?name=${recipientNumber}`,
            status: "offline",
          };
          return [newContact, ...prevContacts];
        }
      });
    };

    socket.on("message:received", handleMessageUpdate);
    socket.on("send-message", handleMessageUpdate);

    return () => {
      socket.off("message:received", handleMessageUpdate);
      socket.off("send-message", handleMessageUpdate);
    };
  }, [socket, activeChatNumber]);

  //  Update tab title based on unread messages
  useEffect(() => {
    const unreadCount = contacts.reduce((sum, c) => sum + (c.unread || 0), 0);
    setTotalUnread(unreadCount);




    if (unreadCount > 0) {
      document.title = `(${unreadCount}) WhatGrowPro`;
    } else {
      document.title = "Live Chat | WhatGrowPro";
    }

  }, [contacts]);

  useEffect(() => {
    pageRef.current = page;
  }, [page]);

  useEffect(() => {
    if (!selectedPhone) return;
    setPage(1);
    setHasMore(true);
    setContacts([]);  // reset list
    setLoading(true); // ← ADDED: ensure skeleton shows immediately on phone/filter switch
    fetchRecipients(1);
  }, [selectedPhone, filter]);

  useEffect(() => {
    console.log("Filter changed:", filter);
  }, [filter]);


  //  Fetch recipients when selected phone changes

  const fetchRecipients = async (pageNumber = 1) => {
    if (!selectedPhone?.id) return;

    setLoading(true);

    try {
      let response;

      //  SWITCH API BASED ON FILTER
      if (filter === "Unread") {
        response = await getAllRecipientByPhoneIdWithStatus(
          selectedPhone.id,
          pageNumber
        );
      } else {
        response = await getAllRecipientByPhoneId(
          selectedPhone.id,
          pageNumber
        );
      }

      const { data, pagination } = response;

      const mappedContacts = data.map((item) => ({
        id: item.id,
        name: item.name,
        number: item.number,
        lastMessage: item.lastMessage,
        type: item.type,
        direction: item.direction,
        status: item.status,
        time: item.lastMessageTime
          ? new Date(item.lastMessageTime).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })
          : "",
        unread: item.unreadCount,
        // image: `https://ui-avatars.com/api/?name=${item.name || item.number}`,
      }));

      if (pageNumber === 1) {
        setContacts(mappedContacts);
      } else {
        setContacts((prev) => [...prev, ...mappedContacts]);
      }

      setHasMore(pagination.hasMore);

      if (pagination.hasMore) {
        setPage(pageNumber + 1);
      }

    } catch (error) {
      console.error("Error fetching recipients:", error);
    } finally {
      setLoading(false);
    }
  };








  const handleScroll = (e) => {
    if (searchTerm.trim()) return; // 🚫 disable scroll during search

    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (
      scrollTop + clientHeight >= scrollHeight - 50 &&
      !loading &&
      hasMore
    ) {
      fetchRecipients(pageRef.current);
    }
  };

  // ── skeleton row that exactly mirrors a real ContactItem ──
  const SkeletonContact = () => (
    <div className="flex items-center gap-3 p-3 border-b border-gray-100">
      {/* circular avatar shimmer — same 48x48 as real avatar */}
      <div className="w-12 h-12 rounded-full bg-gray-200 animate-pulse flex-shrink-0" />
      <div className="flex-1 min-w-0 space-y-2">
        {/* top row: name + time */}
        <div className="flex justify-between items-center">
          <div className="h-3.5 bg-gray-200 animate-pulse rounded-full w-32" />
          <div className="h-2.5 bg-gray-200 animate-pulse rounded-full w-10" />
        </div>
        {/* bottom row: message preview */}
        <div className="h-2.5 bg-gray-200 animate-pulse rounded-full w-44" />
      </div>
    </div>
  );
  // ──────────────────────────────────────────────────────────

  return (
    <div className="w-1/3 border-r bg-white flex flex-col max-w-sm h-screen">
      {/* Header with dropdown */}
      <div className="p-4 bg-[#f0f2f5] flex items-center justify-between">
        <h1 className="font-bold text-xl">
          What<span className="text-[#25D366]">Grow</span>Pro
        </h1>
        <div className="relative">
          <button
            onClick={() => setOpen(!open)}
            className="flex items-center gap-2 px-3 py-1.5 bg-white rounded-lg border shadow-sm text-sm hover:bg-gray-50"
          >
            {selectedPhone
              ? `${selectedPhone.display_phone_number?.startsWith("+")
                ? selectedPhone.display_phone_number
                : `+${selectedPhone.display_phone_number}`}`
              : "Select Phone"}
            <ChevronDown size={16} />
          </button>

          {open && (
            <div className="absolute right-0 mt-2 w-56 bg-white border rounded-lg shadow-lg z-10 max-h-60 overflow-y-auto">
              {phones.map((phone) => (
                <div
                  key={phone.id}
                  onClick={() => {
                    if (selectedPhone?.id !== phone.id) {
                      setContacts([]);
                      setSelectedPhone(phone);
                    }
                    setOpen(false);
                  }}
                  className="px-4 py-2 cursor-pointer hover:bg-gray-100 text-sm"
                >
                  {phone.display_phone_number?.startsWith("+")
                    ? phone.display_phone_number
                    : `+${phone.display_phone_number}`}
                  <div className="text-xs text-gray-500">{phone.verified_name}</div>
                </div>
              ))}

            </div>
          )}
        </div>
      </div>

      {/* Search */}
      <div className="px-3 py-2 bg-[#f0f2f5]">
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <Search size={18} className="text-gray-400" />
          </div>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search or start new chat"
            className="w-full border-none bg-white rounded-lg pl-10 pr-4 py-2 focus:outline-none text-sm"
          />


        </div>
      </div>

      {/* Filters */}
      <div className="flex gap-2 px-3 py-2 bg-[#f0f2f5]">
        {["All",
          "Unread",
          //  "Favorites"
        ].map((btn) => (
          <button
            key={btn}
            type="button"
            onClick={() => setFilter(btn)}
            className={`text-xs px-3 py-1 rounded-full transition-colors ${filter === btn
              ? "bg-[#25D366] text-white"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
              }`}
          >
            {btn}
          </button>
        ))}
      </div>

      {/* Contact List */}
      <div className="flex-1 overflow-y-auto" onScroll={handleScroll}>

        {/* skeleton on initial load OR when switching phone/filter */}
        {loading && contacts.length === 0 ? (
          Array.from({ length: 10 }).map((_, i) => <SkeletonContact key={i} />)
        ) : contacts.length === 0 && !loading ? (
          <div className="p-4 text-sm text-gray-500">No contacts found</div>
        ) : (
          <>
            {

              contacts.map((contact) => (
                <ContactItem
                  key={contact.id}
                  contact={contact}
                  isSelected={selectedContactId?.id === contact.id}

                  onClick={() => {
                    //  Set selected contact
                    setSelectedContactId({
                      id: contact.id,
                      name: contact.name,
                      number: contact.number,
                      phoneId: selectedPhone.id,
                    });

                    setActiveChatNumber(contact.number); // track open chat

                    // Capture all unread message IDs for this contact
                    const unreadMessages = contacts
                      .filter(c => c.number === contact.number && c.unread > 0)
                      .map(c => c.id); // use actual message IDs if available

                    // Clear unread count for this contact locally
                    setContacts(prev =>
                      prev.map(c =>
                        c.number === contact.number ? { ...c, unread: 0 } : c
                      )
                    );

                    // 📨 Emit "message:read" to backend with full unread messages
                    if (socket && unreadMessages.length > 0) {
                      // console.log("Sending read messages:", unreadMessages);
                      socket.emit("message:read", {
                        messageIds: unreadMessages, // array of message IDs
                        recipientNumber: contact.number,
                        phoneId: selectedPhone.id,
                      });
                    }
                  }}
                />
              ))


            }

            {/* ← CHANGED: skeleton rows during pagination scroll instead of "Loading more..." text */}
            {loading && contacts.length > 0 && (
              Array.from({ length: 4 }).map((_, i) => <SkeletonContact key={`scroll-skel-${i}`} />)
            )}
          </>
        )}
      </div>

    </div>
  );
};

const ContactItem = ({ contact, isSelected, onClick }) => {
  const { number, lastMessage, time, unread,
    // image,
    status, name, type, direction } = contact;
  // const showFailed =
  //   direction === "sent" && status === "failed";

  // console.log("contact status:", contact);

  const showOnlineIndicator =
    direction === "received" && status === "read";

  const displayName = name && name.trim() !== "" ? name : number;



  const renderIcon = () => {
    switch (type) {
      case "document":
        return <FileText size={16} className="text-gray-500" />;
      case "audio":
        return <Mic size={16} className="text-gray-500" />;
      case "image":
        return <ImageIcon size={16} className="text-gray-500" />;
      case "video":
        return <Video size={16} className="text-gray-500" />;
      case "template":
        return <LayoutTemplate size={16} className="text-gray-500" />;
      default:
        return null;
    }
  };

  const renderStatusIcon = () => {
    if (direction !== "sent") return null;


    

    switch (status) {
      case "failed":
        return (
          <div className="w-5 h-5 flex items-center justify-center rounded-full">
            <AlertCircle size={16} className="text-red-600 bold" strokeWidth={2.5} />
          </div>
        );

      case "pending":
        return <Clock size={16} className="text-gray-400" />;

      case "sent":
        return <Check size={16} className="text-gray-400" />;

      case "delivered":
        return <CheckCheck size={16} className="text-gray-400" />;

      case "read":
        return <CheckCheck size={16} className="text-blue-500" />;

      default:
        return null;
    }
  };

    const avatarColors = [
    "#94A3B8", // Slate
    "#A8A29E", // Stone
    "#9CA3AF", // Gray
    "#84A59D", // Sage
    "#B08968", // Brown
    "#7C8DB5", // Muted Blue
    "#A188A6", // Muted Purple
    "#8D99AE", // Cool Gray
  ];

  return (
    <div
      onClick={onClick}
      className={`flex items-center gap-3 p-3 cursor-pointer border-b border-gray-100 hover:bg-gray-100 transition-colors ${isSelected ? "bg-gray-200" : ""
        }`}
    >
      {/* Avatar */}
      <div className="relative">
        {/* <img
          src={image}
          alt={name}
          className="w-12 h-12 rounded-full object-cover"
        /> */}
        <Avatar
          name={displayName}
          size="48"
          round={true}
          textSizeRatio={2}
          className="w-12 h-12"
           colors={avatarColors}
        />

        {showOnlineIndicator && (
          <span className="absolute bottom-0 right-0 w-3.5 h-3.5 bg-green-500 border-2 border-white rounded-full"></span>
        )}
      </div>

      {/* Message + Status */}
      <div className="flex-1 min-w-0">
        <div className="flex justify-between items-center">
          {/* <div className="font-semibold truncate">{name}</div> */}
          <div className="font-semibold truncate">{displayName}</div>
          <div className="text-xs text-gray-500">{time}</div>
        </div>

        <div className="flex justify-between items-center">
          {/* LEFT SIDE → status icon + message icon + message text */}
          <div className="flex items-center gap-1 text-sm text-gray-600 truncate max-w-[70%]">
            {direction === "sent" && renderStatusIcon()} {/* ← Status icon on left */}
            {renderIcon()} {/* message type icon */}
            <span className="truncate">{lastMessage}</span>
          </div>

          {/* RIGHT SIDE → only unread badge */}
          <div className="flex items-center">
            {direction !== "sent" && unread > 0 && (
              <div className="bg-[#25D366] text-white text-xs min-w-5 h-5 flex items-center justify-center rounded-full px-1.5">
                {unread}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );



};


export default ContactList;